module.exports = __webpack_public_path__ + "img/Gorgeous-Rose-Tattoo-Designs-For-Women-10.jpg";